import React from 'react';
import Input from '../../../../components/ui/Input';
import Select from '../../../../components/ui/Select';

const LogisticsTab = ({ productData, onFieldChange, validationErrors }) => {
  const packagingOptions = [
    { value: 'caixa', label: 'Caixa' },
    { value: 'envelope', label: 'Envelope' },
    { value: 'saco', label: 'Saco Plástico' },
    { value: 'outro', label: 'Outro' }
  ];

  return (
    <div className="space-y-6">
      {/* Dimensions */}
      <div>
        <h3 className="font-semibold text-foreground mb-4">Dimensões do Produto</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Input
            label="Peso (kg)"
            type="number"
            step="0.01"
            value={productData?.weight}
            onChange={(e) => onFieldChange('weight', e?.target?.value)}
            placeholder="0.00"
            required
            error={validationErrors?.weight}
          />
          
          <Input
            label="Largura (cm)"
            type="number"
            step="0.1"
            value={productData?.width}
            onChange={(e) => onFieldChange('width', e?.target?.value)}
            placeholder="0.0"
            required
            error={validationErrors?.width}
          />
          
          <Input
            label="Altura (cm)"
            type="number"
            step="0.1"
            value={productData?.height}
            onChange={(e) => onFieldChange('height', e?.target?.value)}
            placeholder="0.0"
            required
            error={validationErrors?.height}
          />
          
          <Input
            label="Comprimento (cm)"
            type="number"
            step="0.1"
            value={productData?.length}
            onChange={(e) => onFieldChange('length', e?.target?.value)}
            placeholder="0.0"
            required
            error={validationErrors?.length}
          />
        </div>
      </div>

      {/* Packaging */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label="Peso da Caixa (kg)"
          type="number"
          step="0.01"
          value={productData?.boxWeight}
          onChange={(e) => onFieldChange('boxWeight', e?.target?.value)}
          placeholder="0.00"
          description="Peso da embalagem vazia"
        />
        
        <Select
          label="Tipo de Embalagem"
          options={packagingOptions}
          value={productData?.packagingType}
          onChange={(value) => onFieldChange('packagingType', value)}
        />
      </div>

      {/* Stock */}
      <div>
        <h3 className="font-semibold text-foreground mb-4">Estoque</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Quantidade em Estoque"
            type="number"
            value={productData?.stock}
            onChange={(e) => onFieldChange('stock', e?.target?.value)}
            placeholder="0"
            required
          />
          
          <Input
            label="Estoque Mínimo (Alerta)"
            type="number"
            value={productData?.minStock}
            onChange={(e) => onFieldChange('minStock', e?.target?.value)}
            placeholder="0"
            description="Receba alerta quando atingir este número"
          />
        </div>
      </div>

      {/* Additional Info */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label="Tempo de Fabricação (dias)"
          type="number"
          value={productData?.manufacturingTime}
          onChange={(e) => onFieldChange('manufacturingTime', e?.target?.value)}
          placeholder="0"
          description="Tempo para produzir sob demanda"
        />
        
        <Input
          label="Localização no Estoque"
          value={productData?.stockLocation}
          onChange={(e) => onFieldChange('stockLocation', e?.target?.value)}
          placeholder="Ex: Corredor A, Prateleira 3"
        />
      </div>
    </div>
  );
};

export default LogisticsTab;